import { useGLTF } from '@react-three/drei'

export default function Palais() {
    const { nodes } = useGLTF('./models/palais.glb')

    return (
        <mesh 
            geometry={nodes.palais.geometry}
            onClick={ (event) => event.stopPropagation() }
            onPointerEnter={ (event) => event.stopPropagation()}
        >
            <meshStandardMaterial color={0x392821} />
        </mesh>
    )
}
